import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import getNameByID from "../../../../../functions/getNameByID";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PaidIcon from "@mui/icons-material/Paid";
import { Get_One_From_MongoDB } from "../../../../api/Get_One_From_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../../api/Update_To_MongoDB_By_ID";
import { Update_To_MongoDB_By_ID_And_Send_Confirmation_Email } from "../../api/Update_To_MongoDB_By_ID_And_Send_Confirmation_Email";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function Emails({
  Attendee,
  setAttendee,
  Staff,
  AttendeeOriginal,
  getDifferences,
  setIsSubmitting,
  isSubmitting,
  id,
}) {
  const { logout } = StaffuseAuth();

  //

  let All_Valid_Emails = [];
  //get all emails in Attendee.Contacts where Active is Yes
  if (Attendee && Attendee.Contacts && Array.isArray(Attendee.Contacts)) {
    All_Valid_Emails = Attendee.Contacts.filter(
      (Contact) => Contact.Active === "Yes"
    );
  }
  //if Attendee.IPInfo.EC_ID exists, use Get_One_From_MongoDB to get the EC's email from MongoDB, call it EMAIL_SEARCHED and then add {Person: "Assigned EC", Email: EMAIL_SEARCHED, Active: "Yes"} to All_Valid_Emails
  const [EC, setEC] = useState({});
  useEffect(() => {
    if (Attendee.IPInfo && Attendee.IPInfo.EC_ID) {
      Get_One_From_MongoDB("IP", "EC", Attendee.IPInfo.EC_ID, setEC, logout);
    }
  }, [Attendee.IPInfo.EC_ID]);

  //if EC.BasicInfo.Email exists, add {Person: "Assigned EC", Email: EC.BasicInfo.Email, Active: "Yes"} to All_Valid_Emails
  if (EC && EC.BasicInfo && EC.BasicInfo.Email) {
    All_Valid_Emails.push({
      Person: "Assigned EC",
      Email: EC.BasicInfo.Email,
      Active: "Yes",
    });
  }

  //Just get the .Emails from All_Valid_Emails, and make it a distinct list
  let All_Valid_Emails_Emails = [];
  if (All_Valid_Emails && Array.isArray(All_Valid_Emails)) {
    All_Valid_Emails_Emails = All_Valid_Emails.map((Contact) => Contact.Email);
  }
  let BCC_Emails = [];
  BCC_Emails.push(localStorage.getItem("Username"));

  const distinctEmails = [...new Set(All_Valid_Emails_Emails)];

  const handleSentConfirmationEmail = async (e) => {
    //Get Changes
    const OldData = { ...AttendeeOriginal };
    const NewData = { ...Attendee };
    delete OldData.Notes;
    delete NewData.Notes;
    const differences = getDifferences(OldData, NewData);
    const differencesString = JSON.stringify(differences);
    //got Changes
    let data = Attendee;
    delete data._id;
    //Add differencesString to the Notes section
    if (data && data.Notes && Array.isArray(data.Notes)) {
      data.Notes.push(
        {
          Note: differencesString,
          DateTime: new Date().toISOString(),
          Staff_ID: localStorage.getItem("_id"),
        },
        {
          DateTime: new Date().toISOString(),
          Note: "Sent Confirmation Email",
          Staff_ID: localStorage.getItem("_id"),
        }
      );
    } else {
      data.Notes = [
        {
          Note: differencesString,
          DateTime: new Date().toISOString(),
          Staff_ID: localStorage.getItem("_id"),
        },
        {
          DateTime: new Date().toISOString(),
          Note: "Sent Confirmation Email",
          Staff_ID: localStorage.getItem("_id"),
        },
      ];
    }

    Update_To_MongoDB_By_ID_And_Send_Confirmation_Email(
      data,
      "Registers_2025",
      "All",
      setIsSubmitting,
      id,
      distinctEmails,
      BCC_Emails,
      logout
    );
    setAttendee({
      ...Attendee,
      _id: id,
    });
  };

  return (
    <section>
      <section>
        <h2>Emails </h2>
      </section>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            width: "50%",
            margin: "0",
            overflow: "auto",
          }}
        >
          <Table
            aria-label="simple table"
            sx={{
              border: "1px solid #e0e0e0",
              tableLayout: "fixed",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  className="tableCellHeader" // Add this line to include the CSS class
                  align="left"
                  style={{
                    position: "sticky",
                    Top: 0,
                    zIndex: 1,
                    fontWeight: "bold", // Make Text bold
                    padding: "8px", // Adjust padding as needed To make cells smaller
                  }}
                >
                  Person
                </TableCell>
                <TableCell
                  className="tableCellHeader" // Add this line to include the CSS class
                  align="left"
                  style={{
                    position: "sticky",
                    Top: 0,
                    zIndex: 1,
                    fontWeight: "bold", // Make Text bold
                    padding: "8px", // Adjust padding as needed To make cells smaller
                  }}
                >
                  Email
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {All_Valid_Emails && Array.isArray(All_Valid_Emails) ? (
                All_Valid_Emails.map((Contact, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Contact.Person}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Contact.Email}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexDirection: "column",
            width: "50%",
            marginLeft: "10px",
            marginRight: "10px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => handleSentConfirmationEmail(e)}
            sx={{ marginBottom: "10px" }}
            disabled={isSubmitting}
          >
            Send Confirmation Email & Save Progress
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginBottom: "10px" }}
            disabled={true}
          >
            TBC
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginBottom: "10px" }}
            disabled={true}
          >
            TBC
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Emails;
